import "@ant-design/v5-patch-for-react-19";
import "@fontsource/roboto";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { App } from "App";
import { Provider as NiceModalProvider } from "@ebay/nice-modal-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { VyneANTDProvider } from "@vyne-shared/components/vyneTheme/VyneThemeProvider";
import { applyPendoDisablement } from "utils/usePendo";
import { createRoot } from "react-dom/client";
import { initSentry } from "utils/initSentry";
import { paymentsUiRouter } from "components/Navigation/paymentsUiRouter";
import { reactErrorHandler } from "@sentry/react";
import configuration from "utils/config";

if (configuration.environment.isDevelopment()) {
    void import("@axe-core/react").then((axe) => axe.default(React, ReactDOM, 1000));
}

// note that we no longer connect react-query to Sentry for logging
// per react-query docs, "Logging only had an effect in development mode, where passing a custom logger is not necessary"
// see https://tanstack.com/query/v5/docs/react/guides/migrating-to-v5#the-deprecated-custom-logger-has-been-removed
const queryClient = new QueryClient();

// Initialize Sentry early
initSentry(paymentsUiRouter);

// Disable Pendo when undergoing automated E2E tests.
applyPendoDisablement();

// Application entry point
const container = document.getElementById("root"); // defined in index.html
const root = createRoot(container!, {
    onUncaughtError: reactErrorHandler(),
});

root.render(
    <QueryClientProvider client={queryClient}>
        <VyneANTDProvider>
            <NiceModalProvider>
                <App />
            </NiceModalProvider>
        </VyneANTDProvider>
    </QueryClientProvider>,
);
